import { render, staticRenderFns } from "./user_permissions.vue?vue&type=template&id=92f89a72&"
import script from "./user_permissions.vue?vue&type=script&lang=js&"
export * from "./user_permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports